/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Th_ProviderInputs */

const en_pol_th_provider = /** @type {(inputs: Pol_Th_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const id_pol_th_provider = /** @type {(inputs: Pol_Th_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Pol_Th_ProviderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_th_provider = /** @type {((inputs?: Pol_Th_ProviderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Th_ProviderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_th_provider(inputs)
	return en_pol_th_provider(inputs)
});